import React from 'react';

interface IIconProps {
  width?: number;
  className?: string;
}

const TwitterIcon = (props: IIconProps) => {
  const { width = 24, className } = props;
  const height = (width * 24) / 24;

  return (
    <svg
      className={className}
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 64 45"
      preserveAspectRatio="xMidYMid meet"
    >
      <g transform="translate(0,45) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
        <path
          d="M74 443 c-12 -2 -32 -15 -45 -29 -23 -25 -24 -31 -24 -190 l0 -164
28 -27 27 -28 260 0 260 0 27 28 28 27 0 165 0 165 -28 27 -27 28 -243 1
c-133 1 -252 0 -263 -3z m337 -221 c-4 -7 -149 -92 -157 -92 -6 0 -5 176 1
182 8 8 161 -81 156 -90z"
        />
      </g>
    </svg>
  );
};

export default React.memo(TwitterIcon);
